import React from 'react';
import { useEffect, useState } from "react";
import { ProgressBar } from "../../Components";
import { useColors } from "../../constants/useColors";

type ProgressTimerProps = {
    total_time:number,
    time_id:string,
    update_multiplier?: number
    onTimesUp:() => void
}

const ProgressTimer = ({total_time, time_id, onTimesUp}:ProgressTimerProps) => {
    const Colors = useColors();
    const [ started, setStarted ] = useState(false);
     const [ seconds_remaining, setSecondsRemaining ] = useState(0);

    useEffect(() => {
        if(!time_id){ return }
        setSecondsRemaining(total_time);
        setStarted(true);
    },[time_id])

    useEffect(() => {
        if(!started){ return }
        if(seconds_remaining > 0){
            setTimeout(() => setSecondsRemaining(seconds_remaining - 1), 1000);
        } else {
            onTimesUp();
            setStarted(false);
        }
    },[seconds_remaining])


    if(seconds_remaining == 0){ return <></> }
    return (
        <ProgressBar
            max_value={total_time}
            hide_labels
            current_value={seconds_remaining}
            background_color={Colors.views.background}
            fill_color={Colors.text.action}
        />
    )
}

export default ProgressTimer